import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=6aac39e9&"
import script from "./exhibition.vue?vue&type=script&lang=ts&"
export * from "./exhibition.vue?vue&type=script&lang=ts&"
import style0 from "./exhibition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports